import React from 'react';
import {withRouter} from "react-router";

import ProductLcrGeoRestrictionsForm from "../forms/ProductLcrGeoRestrictionsForm";
import ProductLcrGeoRestrictionsModel from "../forms/ProductLcrGeoRestrictionsModel";

import {createForm} from "../../../utils/forms";

import {ProductLctGeoRestrictionsEdit} from "./ProductLctGeoRestrictionsEdit";

export class ProductLcrGeoRestrictionsEdit extends ProductLctGeoRestrictionsEdit {
    renderForm = () => {
        const Form = createForm(
            ProductLcrGeoRestrictionsModel,
            ProductLcrGeoRestrictionsForm, {
                dataRequest: true,
                id: this.props.clientProductId,
            });

        return <Form/>;
    };
}

export default withRouter(ProductLcrGeoRestrictionsEdit)
